/* global $ */

(function (angular) {
    'use strict';

    angular.module('app')
        .directive('formErrors', formErrors);

    formErrors.$inject = [
        'alerts',
        '$timeout'
    ];

    /**
     * Give this directive your form errors as returned by the API (object / array) and it'll handle them for you.
     * @ngdoc directive
     * @example
     * <form name="signin" form-errors="vm.errors">
     */
    function formErrors(
        alerts,
        $timeout
    ) {

        function formErrorsLink($scope, el) {
            var _this = this;
            el = $(el);

            $scope.$watch('formErrors', function (errors) {
                $timeout(handleErrors.bind(_this, errors || {}), 0);
            }, true);

            /**
             * Removes all errors currently displayed on the form
             * @return {void}
             */
            function resetErrors() {
                $(el).find('[class^="form-error"]').remove();
                $(el).find('[name]').removeClass('has-error');
                // $(el).find('input, textarea, select').removeClass('has-error');
                $(el).find('ul.nav-tabs li').removeClass('has-form-error');
            }

            /**
             * Adds error styling to a form message, and error message below it
             * @param {string} errorMessage - message to show below the form field
             * @param {string/int} name  - name attribute of the form field OR index of error
             * @return {void}
             */
            function showError(errorMessage, name) {
                errorMessage = (typeof errorMessage === 'string' ? errorMessage : errorMessage.join('<br />'))
                .replace(' custom attrs', '');

                var $input,
                    errorEl = '<span class="form-error" data-for="' + name + '">' + errorMessage + '</span>';

                if (name === parseInt(name, 10)) {
                    $(el).append(errorEl);
                } else {
                    $input = $(el).find('[name="' + name + '"]');

                    if ($input.length) {
                        $input
                            .addClass('has-error')
                            .after(errorEl);

                        showTabIndicator($input);
                    } else {
                        $(el).append(errorEl);
                    }
                }
            }

            /**
             * Adds an indicator to any parent tabs, to show there is a form error within it's content
             * @param  {string} $input - jQuery element with error message now shown
             * @return {void}
             */
            function showTabIndicator($input) {
                // Is this inside a tab?
                const $tabContent = $input.closest('.tab-pane');

                if ($tabContent.length) {
                    // Get tab name (has to be manually added to the markup, somewhere in the tab content)
                    const tabName = $tabContent.find('[form-errors-tab]').attr('form-errors-tab');

                    if (tabName) {
                        // Add error indicator to this tab
                        $('ul.nav-tabs li[index="' + '\'' + tabName + '\'' + '"]').addClass('has-form-error');
                    }

                }
            }

            /**
             * Focusses on the first form element with an error
             */
            function focusForm() {
                var errorElement = el.find('.has-error:first-child');

                // Check whether the element is focussable
                if (errorElement.is('a,input,select,textarea,button')) {
                    errorElement.focus();
                }
            }

            /**
             * Determines what to do with the provided error data
             * @param  {mixed} errors - Should be an array or object
             * @return {void}
             */
            function handleErrors(errors) {
                errors = errors.data || errors;

                if (Array.isArray(errors)) {
                    alerts.emit(errors);
                    return;
                }

                if (typeof errors === 'object') {
                    resetErrors();
                    angular.forEach(errors, showError);
                    focusForm();
                    return;
                }

                console.warn('Unreadable form error', errors);
            }
        }

        return {
            restrict: 'A',
            link: formErrorsLink,
            scope: {
                formErrors: '='
            }
        };
    }

}(angular));
